import { useTranslation } from 'react-i18next';
import SectionHeader from 'components/sectionHeader/SectionHeader';
import Button from 'components/button/Button';
import { Glyphicon } from 'react-bootstrap';
import PropertyEditActionWrapper from 'pages/property/common/PropertyEditActionWrapper';
import CancellationPolicyTable from './CancellationPolicyTable';
import useCancellationPolicyData from './useCancellationPolicyData';
import useCancellationPolicyModal from './modals/useCancellationPolicyModal';

const CancellationPolicy = () => {
  const { t } = useTranslation();
  const { cancellationPolicyData } = useCancellationPolicyData();
  const { openAddModal } = useCancellationPolicyModal();

  const hasCancellationPolicy = !!cancellationPolicyData?.values.length;

  return (
    <section data-testid="property-cancellation-policy-section">
      <SectionHeader
        id="cancellation-policy-header"
        title={t('pageProperty.feesTaxesAndPolicies.cancellationPolicy.title')}
        tooltip={t(
          'pageProperty.feesTaxesAndPolicies.cancellationPolicy.tooltipTitle',
        )}
        buttons={
          !hasCancellationPolicy && (
            <PropertyEditActionWrapper tooltipId="cancellation-policy-header-button-tooltip">
              <Button
                bsStyle="primary"
                data-testid="cancellation-policy-header-button"
                onClick={openAddModal}
              >
                <Glyphicon glyph="plus" />
                {t(
                  'pageProperty.feesTaxesAndPolicies.cancellationPolicy.addButton',
                )}
              </Button>
            </PropertyEditActionWrapper>
          )
        }
      />

      <CancellationPolicyTable />
    </section>
  );
};

export default CancellationPolicy;
